module.exports = __webpack_public_path__ + "static/media/logo.b0e34c62.svg";